import { mapTokensToPalette } from "./token-adaptor";
import type {
	ColorSystemOptions,
	PaletteColorOptions,
} from "@mui/material/styles";

import type { ColorScheme } from "./types";
import type { Brand } from "@/types/brand.types";

declare module "@mui/material/styles" {
	interface PaletteColor {
		activated?: string;
		hovered?: string;
		selected?: string;
	}

	interface SimplePaletteColorOptions {
		activated?: string;
		hovered?: string;
		selected?: string;
	}

	interface TypeBackground {
		level1: string;
		level2: string;
		level3: string;
	}

	interface PaletteOptions {
		neutral?: PaletteColorOptions;
		shadow?: string;
		Avatar?: { defaultBg?: string };
		Backdrop?: { bg?: string };
		OutlinedInput?: { border?: string };
		TableCell?: { border?: string };
		Tooltip?: { bg?: string };
	}
}

export function colorSchemes(
	brand: Brand
): Partial<Record<ColorScheme, ColorSystemOptions>> {
	const lightPalette = mapTokensToPalette(brand, "light");
	const darkPalette = mapTokensToPalette(brand, "dark");

	// Warm up backgrounds with a subtle blue tint for a more cohesive, polished feel
	if (lightPalette.background) {
		lightPalette.background = {
			...lightPalette.background,
			default: "#FAFBFD",
			level1: "#F4F6FA",
			level2: "#ECEEF4",
		};
	}

	return {
		dark: {
			palette: darkPalette,
		},
		light: {
			palette: lightPalette,
		},
	};
}
